<!--
 * @Author: MouXiaowei
 * @Date: 2023-03-15 15:34:06
 * @Description: 通过接口获取HTML展示
-->

<template>
    <div class="content-box">
        <div v-html="content"></div>
    </div>
  </template>

<script>

import { setStore } from '@/utils/index'
import { queryHTMLInfo } from '@/api/active'

export default {
  data () {
    return {
      content: ''
    }
  },
  mounted () {
    const accessToken = this.$route.query.accessToken
    if (accessToken) {
      setStore('token', accessToken)
    }
    this.qurInfo()
  },
  methods: {
    qurInfo () {
      const code = this.$route.query.code
      const type = this.$route.query.type
      if (code) {
        const queryList = {
          appInfo: {
            sourceSystem: type
          },
          code: code
        }
        queryHTMLInfo(queryList).then((res) => {
          if (res.data.code === 200) {
            if (res.data) {
              if (res.data.result) {
                const content = res.data.result
                // this.content = content
                window.sessionStorage.removeItem('callbackHTML')
                window.sessionStorage.setItem('callbackHTML', content)
                // window.location.href = window.location.href.split('/pages/')[0] + '/pages/activeimg/htmlCallback.html'
                // let newWin = window.open('', 'htmlCallback')
                // newWin.document.write(localStorage.getItem('callbackHTML'))
                // newWin.document.close()
                // window.open(window.location.protocol + '//' + window.location.host + '/appweb/' + 'htmlCallback.html')
                // window.location.href = 'http://bjweb.tj.aqdpay.com/appweb/htmlCallback.html'
                // window.open('http://bjweb.tj.aqdpay.com/appweb/' + 'htmlCallback.html')
                window.location.href = 'http://bjweb.tj.aqdpay.com/appweb/' + 'htmlCallback.html'
                // newWin.document.write(window.sessionStorage.getItem('callbackHTML'))
                // newWin.document.close()
              }
            }
          }
        })
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
    .content-box {
      margin-top: 10px;
      min-height: 100vh;
      background-color: #fff;
    }
  </style>
